import { Routes } from '@angular/router';
import { LoanSummaryComponent } from './loan-summary/loan-summary.component';
import { LoanDetailComponent } from './loan-detail/loan-detail.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';

export const LOAN_ROUTES: Routes = [
  {
    path: '',
    component: LoanSummaryComponent
  },
  {
    path: 'detail',
    component: LoanDetailComponent
  },
  {
    path: 'payment',
    component: MakePaymentComponent
  }
];
